import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=8160acbe&scoped=true&"
import script from "./AdminLogin.vue?vue&type=script&lang=ts&"
export * from "./AdminLogin.vue?vue&type=script&lang=ts&"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=8160acbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8160acbe",
  null
  
)

component.options.__file = "AdminLogin.vue"
export default component.exports